import {registerStore} from '../../store'
import Bb from '../../config/backbone'
import boardConfig from '../board/config'
import Players from '../players/collection/Player'
import PlayersHistory from '../players/collection/PlayersHistory'
import PlayedGamesHistory from '../history/collection/PlayedGamesHistory'
import Settings from './Settings'
import Game from './Game'


const Levels = Bb.Collection.extend()


const _players = [
    {
        id: 1,
        name: 'Alaa',
        image: 'http://api.sunny.fr/images/mustache.jpg',
        scoreBoard: []
    },
    {
        id: 2,
        name: 'Suzy',
        image: 'http://api.sunny.fr/images/sooz.jpg',
        scoreBoard: []
    },
    {
        id: 3,
        name: 'Cyril',
        image: 'http://api.sunny.fr/images/cyril.jpg',
        scoreBoard: []
    },
    {
        id: 4,
        name: 'JM',
        image: 'http://api.sunny.fr/images/jm.jpg',
        scoreBoard: []
    },
    {
        id: 5,
        name: 'MC',
        image: 'http://api.sunny.fr/images/mc.jpg',
        scoreBoard: []
    },
    {
        id: 6,
        name: 'Julie',
        image: 'http://api.sunny.fr/images/julie.jpg',
        scoreBoard: []
    },
    {
        id: 7,
        name: 'Martine',
        image: 'http://api.sunny.fr/images/martinus.jpg',
        scoreBoard: []
    },
    {
        id: 8,
        name: 'Thomas',
        image: 'http://api.sunny.fr/images/thomas.jpg',
        scoreBoard: []
    },
    {
        id: 9,
        name: 'Patrick',
        image: 'http://api.sunny.fr/images/patrick.jpg',
        scoreBoard: []
    },
    {
        id: 10,
        name: 'Nico',
        image: 'http://api.sunny.fr/images/nico.jpg',
        scoreBoard: []
    },
    {
        id: 11,
        name: 'Popo',
        image: 'http://api.sunny.fr/images/pauline.jpg',
        scoreBoard: []
    }
]


//const _players = [{"name":"Alaa","image":"http://api.sunny.fr/images/mustache.jpg","scoreBoard":[{"id":"nums-1","value":4},{"id":"nums-2","value":8},{"id":"nums-3","value":12},{"id":"nums-4","value":0},{"id":"nums-5","value":20},{"id":"nums-6","value":6},{"id":"ofakind-3","value":14},{"id":"custom-l","value":63},{"id":"custom-s","value":22},{"id":"custom-m","value":52},{"id":"flush-s","value":30},{"id":"flush-l","value":40},{"id":"ofakind-4","value":60},{"id":"ofakind-5","value":60},{"id":"fullhouse","value":85}],"id":1},{"name":"Suzy","image":"http://api.sunny.fr/images/sooz.jpg","scoreBoard":[{"id":"nums-1","value":1},{"id":"nums-2","value":4},{"id":"nums-3","value":9},{"id":"nums-4","value":16},{"id":"nums-6","value":0},{"id":"nums-5","value":10},{"id":"custom-s","value":66},{"id":"custom-m","value":33},{"id":"custom-l","value":99},{"id":"ofakind-3","value":23},{"id":"fullhouse","value":110},{"id":"flush-s","value":30},{"id":"flush-l","value":40},{"id":"ofakind-4","value":60},{"id":"ofakind-5","value":75}],"id":2}]


const levels = new Levels(boardConfig.levels)
levels.defaultData = boardConfig.levels.concat()

const players = new Players(/*_players*/)
//players.defaultData = _players.concat()

const settings = new Settings()

const game = new Game()

const playersHistory = new PlayersHistory(_players)

const playedGamesHistory = new PlayedGamesHistory()


function autoconf() {
    registerStore(levels, 'levels')
    registerStore(players, 'players')
    registerStore(settings, 'settings')
    registerStore(playersHistory, 'playersHistory')
    registerStore(playedGamesHistory, 'playedGamesHistory')
    registerStore(game, 'game')
}


export default autoconf







// WEBPACK FOOTER //
// ./src/game/config/autoconf.js